import { makeStyles } from "@material-ui/styles";
import { Page } from "components";
import React from "react";
import { Header } from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    height: "100%"
  },
  container: {
    marginTop: theme.spacing(3)
  }
}));

const AppDownload = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Mobile App Download">
      <Header />
    </Page>
  );
};

export default AppDownload;
